import { useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


export const useCelebration = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [employees, setEmployee] = useState({
        birthday: [],
        anniversary: [],
        newJoinee: []
    })
    const [filterValues, setFilterValues] = useState({
        activeFilter: 'Today',
        filters: ['Yesterday', 'Today', 'Tomorrow']
    })
    const [loader, setLoader] = useState(false);


    useEffect(() => {
        getCelebratedDetails(filterValues.activeFilter)
    }, [])

    const getDates = (currentFilter) => {
        const now = new Date();
        if (currentFilter === 'Today') {
            return new Date();
        } else if (currentFilter === 'Yesterday') {
            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);
            return yesterday;
        } else if (currentFilter === 'Tomorrow') {
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            return tomorrow;
        }
    }

    function getWeekNumberSimple(date = new Date()) {
        const start = new Date(date.getFullYear(), 0, 1);
        const diff = date - start;
        const oneWeek = 7 * 24 * 60 * 60 * 1000;
        return Math.floor(diff / oneWeek) + 1;
    }

    const getCelebratedDetails = async (filter) => {
        setLoader(true)
        const payload = {
            "request_date": getDates(filter),
            "week_number": getWeekNumberSimple()
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETCELEBRATEPLUSDETAILS'), payload);
            if (res?.body?.data) {
                setEmployee((prevState) => ({
                    ...prevState,
                    birthday: res?.body?.data?.birthday,
                    anniversary: res?.body?.data?.anniversary,
                    newJoinee: res?.body?.data?.newjoinee
                }))
            }
            setLoader(false)
        }
        catch (error) {
            console.error(error, "error");
            setLoader(false)

        }

    }

    const headerTemplate = (options, count, key) => {
        return (
            <div
                className="d-flex gap-1"
                style={{ cursor: 'pointer' }}
                onClick={options.onClick}
            >
                {count > 0 ? <div className="custom-bagde">{count}</div> : null}
                <span className="white-space-nowrap mb-1" style={{ fontSize: 'small', fontWeight: 500 }}>{key}</span>
            </div>
        );
    };

    const handleFilterClick = (filter) => {
        setFilterValues((prevState) => ({
            ...prevState,
            activeFilter: filter
        }));
        getCelebratedDetails(filter)
    };

    const EmployeeCard = ({ type }) => {
        return (
            <div className="d-flex flex-column justify-content-center" style={{ height: '100%' }}>
                {
                    type !== "newJoinee" && <div className="d-flex gap-4 justify-content-center left-pannle">
                        {filterValues.filters.map((filter) => (
                            <span
                                key={filter}
                                className={filter === filterValues.activeFilter ? 'active-filter' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleFilterClick(filter);
                                }}
                            >
                                {filter}
                            </span>
                        ))}
                    </div>
                }
                <EmployeeCarousel employees={employees} type={type} />
            </div>
        )
    };


    return useMemo(() => ({
        employees, activeIndex, setActiveIndex, EmployeeCard, loader, headerTemplate
    }), [employees, activeIndex, setActiveIndex, EmployeeCard, loader, headerTemplate
    ])
}




const EmployeeCarousel = ({ employees, type }) => {
    const ITEMS_PER_SLIDE = 2;
    const [current, setCurrent] = useState(0);
    const items = employees[type] || [];
    const totalSlides = Math.ceil(items?.length / ITEMS_PER_SLIDE);
    const handlePrev = () => {
        setCurrent(current === 0 ? totalSlides - 1 : current - 1);
    };
    const handleNext = () => {
        setCurrent(current === totalSlides - 1 ? 0 : current + 1);
    };
    if (items?.length === 0) {
        return (
            <div className='text-center'>
                <img src={"./assets/nodata.jpg"} alt='no data' style={{ width: "30%" }} />
                <p className='text-center red' style={{ fontSize: 'x-small' }}> Data Not Found</p>
            </div>
        );
    }
    const slideItems = items?.slice(current * ITEMS_PER_SLIDE, current * ITEMS_PER_SLIDE + ITEMS_PER_SLIDE);
    return (
        <div style={{ width: "100%", height: "85%", display: "flex" }}>
            <div className="d-flex justify-content-between align-items-center w100" >
                {
                    items?.length > ITEMS_PER_SLIDE && <div>
                        <span
                            style={{
                                border: "1px solid gray",
                                borderRadius: "50%",
                                padding: "2px 8px",
                                opacity: current === 0 ? 0.5 : 1,
                                pointerEvents: current === 0 ? "none" : "auto",
                                cursor: "pointer",
                            }}
                            onClick={handlePrev}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-angle-left" />
                        </span>
                    </div>
                }
                <div style={{ width: "100%" }}>
                    {slideItems?.map((item, i) => (
                        <div className="person" key={i}>
                            <div className="d-flex gap-2 w100">
                                <span className="profile">
                                    {item?.image_url
                                        ? <img src={item.image_url} alt="" />
                                        : item?.gender?.trim() === 'F'
                                            ? <img src="./assets/women.png" alt="women" className='rounded-circle' />
                                            : <img src="./assets/man.png" alt="man" className='rounded-circle' />}
                                </span>
                                <div className="birthday-user">
                                    <div className="user-name">{item.user_display_name}</div>
                                    <div className="category">
                                        {type === 'birthday' ? '🍰' : type === 'anniversary' ? '💍' : '👏'} {type.charAt(0).toUpperCase() + type.slice(1)}
                                    </div>
                                </div>
                            </div>
                            <div>
                                {/* <button className="wish-btn">Wish</button> */}
                            </div>
                        </div>
                    ))}
                </div>
                {
                    items?.length > ITEMS_PER_SLIDE && <div>
                        <span
                            style={{
                                border: "1px solid gray",
                                borderRadius: "50%",
                                padding: "2px 8px",
                                opacity: current === totalSlides - 1 ? 0.5 : 1,
                                pointerEvents: current === totalSlides - 1 ? "none" : "auto",
                                cursor: "pointer"
                            }}
                            onClick={handleNext}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-angle-right" />
                        </span>
                    </div>
                }
            </div>
        </div>
    );
};